import { Box, Theme, Typography, useTheme } from '@mui/material';
import { useSession } from 'contexts/session';
import React from 'react';
import { getCountryFlag } from 'utils/asset';

export const UserCountries: React.FC = () => {
  const theme = useTheme() as Theme;
  const [session] = useSession();

  if (!session || !session.allowedCountries.length) {
    return null;
  }

  return (
    <Box display={'flex'}>
      {session.allowedCountries.map(country => (
        <Box key={country.codeIso3} pl={4} display="flex" alignItems="center" gap={2}>
          <Box component="img" src={getCountryFlag(country.codeIso3)} display="block" width={60} height={40} alt="" />
          <Box>
            <Typography mb={-1} variant="body2" component="div" color={theme.palette.custom.primary.brand[50]}>
              <strong>{country.whoRegion.name}</strong>
            </Typography>
            <Typography variant="subtitle1" component="div">
              <strong>{country.name}</strong>
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
